module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-41.e145ca3.woff2";